import { ClickInputInstruction } from '../ClickInputInstruction'

export class SameBillingAndShippingAddressInstructionInstruction extends ClickInputInstruction {
  constructor ({ waitForNoLoaders, label, click }) {
    super({
      name: 'SameBillingAndShippingAddressInstruction',
      waitForNoLoaders: waitForNoLoaders === undefined ? true : waitForNoLoaders,
      label: label || 'My billing and shipping address are the same',
      click: click === undefined ? true : click

    })
  }
}
